import axiosInstance from "../axios/axios";

const login = async (body) => {

    try {
        const response = await axiosInstance.post('/User/login', body); // replace with your endpoint
        //.log('login--->', response?.data);
        return response;
    } catch (error) {
        console.error('Error fetching login:', error);
    }
}
const reachList = async () => {
    try {
        const response = await axiosInstance.get('/reach/getall'); // replace with your endpoint
        //console.log('reachList--->', response?.data);
        return response;
    } catch (error) {
        console.error('Error fetching reachList:', error);
    }
}
const getReachById = async (reachId) => {
    console.log('getReachById===>', reachId);
    try {
        const response = await axiosInstance.get(`/reach/Getbyid/${reachId}`); // replace with your endpoint
        //console.log('getReachById--->', response?.data);
        return response;
    } catch (error) {
        console.error('Error fetching getReachById:', error);
    }
}

const updateReach = async (reachId, body) => {
    console.log('updateReach===>', reachId, body);
    try {
        const response = await axiosInstance.put(`/reach/Update/${reachId}`, body); // replace with your endpoint
        //console.log('updateReach--->', response?.data);
        return response;
    } catch (error) {
        console.error('Error fetching updateReach:', error);
    }
}
const deleteReach = async (reachId) => {
    console.log('DeleteReach===>', reachId);
    try {
        const response = await axiosInstance.delete(`/reach/Delete/${reachId}`); // replace with your endpoint
        //console.log('DeleteReach--->', response?.data);
        return response;
    } catch (error) {
        console.error('Error fetching DeleteReach:', error);
    }
}
const generateToken = async (body) => {
    try {
        const response = await axiosInstance.post('/User/generateToken', body); // replace with your endpoint
        //console.log('generateToken--->', response?.data);
        return response;
    } catch (error) {
        console.error('Error fetching generateToken:', error);
    }
}
export const AuthService = {
    login,
    generateToken
}